<template>
  <group-card
    title="Insurance"
    icon="beach_access"
    :disabled="hasFinalizedSubmission"
  >
    <template slot="actions">
      <md-button
        v-if="showQuoteButton"
        class="md-primary"
        @click="openRequestInsuranceModal"
      >
        {{ insuranceQuoteButtonText }}
      </md-button>
    </template>
    <InsuranceQuoteRequestModal :visible="showRequestInsuranceModal" @close="showRequestInsuranceModal = false" />
    <InsuranceQuoteModal :visible="showQuoteModal" @close="showQuoteModal = false" />
    <div class="md-layout">
      <p class="md-layout-item h5" style="font-weight: bold">SOLD</p>
      <div class="md-layout-item md-small-size-12.5 md-size-12.5"></div>
      <div class="md-layout-item md-small-size-12.5 md-size-12.5"></div>
      <div class="md-layout-item md-small-size-12.5 md-size-12.5"></div>
      <div class="md-layout-item md-small-size-12.5 md-size-12.5"></div>
      <div class="md-layout-item md-small-size-12.5 md-size-12.5"></div>
      <div class="md-layout-item md-small-size-12.5 md-size-12.5"></div>
      <p class="md-layout-item h5" style="margin-left: -35%; font-weight: bold;">ADD TO FINANCE</p>
    </div>
    <div
      class="md-layout input-layout"
      v-for="insurance in application.loan.insurances"
      :key="insurance.type"
    >
      <md-checkbox class="md-layout-item" v-model="insurance.enabled"
        ><strong>{{ insurance.type_name }}</strong></md-checkbox
      >
      <validated-autocomplete-input
        class="md-layout-item md-small-size-12.5 md-size-6"
        v-model="insurance.insurer"
        :options="options.insurance_provider"
        label="Insurer"
        :disabled="disable_field(insurance)"
        force
      />
      <validated-text-input
        v-if="hide_field(insurance)"
        :disabled="disable_field(insurance)"
        class="md-layout-item md-small-size-12.5 md-size-12.5"
        v-model="insurance.policy"
        label="Product"
      />

      <validated-number-input
        v-if="hide_field(insurance)"
        :disabled="disable_field(insurance)"
        class="md-layout-item md-small-size-12.5 md-size-12.5"
        v-model="insurance.term"
        label="Cover Term"
      />
      <span
        v-if="!hide_field(insurance)"
        class="md-layout-item md-small-size-12.5 md-size-12.5">
        <md-button
          @click="OpenGeneratePolicy(insurance)"
          class="md-primary"
        >
          <md-tooltip md-direction="bottom">Generate</md-tooltip>
          Generate Policy
        </md-button>
      </span>
      <validated-input
        v-if="hide_field(insurance)"
        :disabled="disable_field(insurance)" 
        type="REQUIRED_DATE"
        class="md-layout-item md-small-size-12.5 md-size-12.5"
        v-model="insurance.policy_end_date"
        label="Policy End Date"
      />
      <validated-number-input
        v-if="hide_field(insurance)"
        :disabled="disable_field(insurance)"
        class="md-layout-item md-small-size-12.5 md-size-12.5"
        v-model="insurance.premium"
        label="Premium"
        prefix="$"
      />
      <validated-number-input
        v-if="hide_field(insurance)"
        :disabled="disable_field(insurance)"
        class="md-layout-item md-small-size-12.5 md-size-12.5"
        v-model="insurance.income"
        label="Income"
        prefix="$"
      />
      <validated-autocomplete-input
        v-if="hide_field(insurance)"
        :disabled="disable_field(insurance)"
        class="md-layout-item md-small-size-10 md-size-10"
        label="Frequency"
        v-model="insurance.frequency"
        :options="filteredPaymentFrequencies"
        force
      />
      <validated-text-input
        v-if="hide_field(insurance)"
        :disabled="disable_field(insurance)"
        class="md-layout-item md-small-size-12.5 md-size-12.5"
        v-model="insurance.policy_number"
        label="Policy Number"
      />
      <md-checkbox
        type="checkbox"
        class="md-layout-item"
        v-model="insurance.include_in_naf"
      />
      <span
        v-if="disable_field(insurance)"
        class="md-layout-item md-small-size-12.5 md-size-12.5">
        <md-button
          @click="OpenGeneratePolicy(insurance)"
          class="md-primary"
        >
          <md-tooltip md-direction="bottom">View Policy Details</md-tooltip>
          Detail
        </md-button>
      </span>
    </div>
    <generate-policy-popup
        v-if="ShowGeneratePolicyPopUp"
        :insurance="{...selectedInsurance}"
        :application ="application"
        :visible="ShowGeneratePolicyPopUp"
        @onCancel="ShowGeneratePolicyPopUp = false"
        @onSucess="ShowGeneratePolicyPopUp = false"
    ></generate-policy-popup>

  </group-card>
</template>

<script>
import { mapGetters } from "vuex";
import filters from "@/components/utils/filters";
import ValidatedInputs from "@/components/ValidatedInput";
import GroupCard from "@/components/Cards/GroupCard";
import GroupCardRow from "@/components/Cards/GroupCardRow";
import GeneratePolicyPopup from "./GeneratePolicyPopup";
import InsuranceQuoteRequestModal from "../Modals/InsuranceQuoteRequestModal.vue";
import InsuranceQuoteModal from "../Modals/InsuranceQuoteModal.vue";
import axios from "axios";

export default {
  components: {
    ...ValidatedInputs,
    GroupCard,
    GroupCardRow,
    GeneratePolicyPopup,
    InsuranceQuoteRequestModal,
    InsuranceQuoteModal,
  },
  props: {
    value: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      products: [],
      vehicleMakes: [],
      vehicleModels: [],
      warrantyTypes: [],
      warrantyOptions: [],
      warrantyTerms: [],
      productM: "Dealer",
      ShowGeneratePolicyPopUp: false,
      selectedInsurance: null,
      showRequestInsuranceModal: false,
      showQuoteModal: false,
      insuranceQuoteExist: false,
      showQuoteButton: false,
    };
  },
  computed: {
    // standard list of options from store
    ...mapGetters({
      options: "options",
      application: "application"
    }),
    filteredPaymentFrequencies() {
      return this.options.payment_frequency_options.filter(option => 
        option === 'Monthly' || option === 'Yearly'
      );
    },
    // internal reference to the v-model on this component, handles incomeing and outgoing changes
    application: {
      get() {
        return this.value;
      },
      set(application) {
        this.$emit("input", application);
      },
    },

    hasFinalizedSubmission() {
      return this.application.loan.submission.active.is_settled;
    },

    insuranceQuoteButtonText() {
      return this.insuranceQuoteExist ? "View Insurance Quote" : "Request Insurance Quote";
    }
  },
  methods: {
    async OpenGeneratePolicy(insurance) {
      this.selectedInsurance = {...insurance};
      this.ShowGeneratePolicyPopUp = true;
    },
    // make all filters available as methods
    ...filters,
    async searchProducts(query) {
      if (query.length > 0) {
        let data = this.products.filter((product) => {
          return product.name
            .toLocaleLowerCase()
            .includes(query.toLocaleLowerCase());
        });
        return data;
      }
      return query.slice(0, 50);
    },
  //TODO: REMOVE Disable from the string to enable integrity api integration when ready
    hide_field (insurance) {
        return insurance.insurer != 'Disable Integrity Insurance' || insurance.policy_number;
    },

    disable_field (insurance) {
        return (insurance.insurer == 'Disable Integrity Insurance' && insurance.policy_number);
    },
    openRequestInsuranceModal() {
      if (this.insuranceQuoteExist) {
        this.showQuoteModal = true;
      } else {
        this.showRequestInsuranceModal = true;
      }
    }
  },
  filters: {
    // make all filters available as filters
    ...filters,
  },
  async beforeCreate() {
    const params = {
      types: [
        'insurance_provider',
        'payment_frequency_options',
      ],
    }
    await this.$store.dispatch('fetch_types', { params });
  },
  async created() {
    if (this.application?.loan?.submission?.active?.id) {
      let response = await axios.post('/api/v1/service_search_by_name',  {
        service_name: 'Huddle Insurance Quote',
      });
      if (response.data?.success) {
        this.showQuoteButton = true;
      } else {
        this.showQuoteButton = false;
      }
    }

    if ((this.application?.loan?.quotes?.insurance?.metadata)) {
      this.insuranceQuoteExist = true;
    }
  }
};
</script>
